module.exports = __webpack_public_path__ + "static/media/codevein.598647af.jpg";